import { unauthorizedApi } from '@omnicomm/shared';
import {
  type AuthorizationRequest,
  AuthorizationRequestSchema,
  type AuthorizationTokens,
  AuthorizationTokensSchema,
} from './types';

export async function performAuthorization(authorizationRequest: AuthorizationRequest) {
  AuthorizationRequestSchema.parse(authorizationRequest);
  const authorizationTokens = await unauthorizedApi
    .post('auth/internal/login', {
      json: authorizationRequest,
      searchParams: {
        jwt: authorizationRequest.jwt ? 'true' : 'false',
      },
    })
    .json<AuthorizationTokens>();
  AuthorizationTokensSchema.parse(authorizationTokens);
  return authorizationTokens;
}
